import React from 'react';

export const UserContext = React.createContext(undefined);

export const TypeOfMatchesContext = React.createContext(undefined);
